<template>
  <div id="uyh-home">
    <IntroCta/>
  </div>
</template>

<script>
  import IntroCta from '@/components/Landing_IntroCta.vue'

  export default {
    name: 'home',
    components: {
      IntroCta
    },
    beforeMount: function () {
      this.$store.dispatch('updateShare', false);
      this.$store.dispatch('updateMantrapage', false);
    }
  }
</script>

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    #uyh-home {
      min-height: calc(100vh - 92px);
    }
  }
</style>
